import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/modules/shared.module';
import { OrdersalesTiendaListComponent } from './ordersales-tienda-list/ordersales-tienda-list.component';
import { OrdersalesTiendaStep1Component } from './ordersales-tienda-step1/ordersales-tienda-step1.component';
import { OrdersalesTiendaStep1ListComponent } from './ordersales-tienda-step1-list/ordersales-tienda-step1-list.component';
import { OrdersalesTiendaStep2ListComponent } from './ordersales-tienda-step2-list/ordersales-tienda-step2-list.component';

@NgModule({
    imports: [
        SharedModule
    ],
    exports: [],
    declarations: [
        OrdersalesTiendaListComponent,
        OrdersalesTiendaStep1Component,
        OrdersalesTiendaStep1ListComponent,
        OrdersalesTiendaStep2ListComponent
    ],
    providers: [],
})
export class OrderSalesTiendaModule { }